import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IModalData } from '@core/interfaces/imodal-data';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { WelcomeModalComponent } from 'src/app/component/welcome-modal/welcome-modal.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeComponent implements OnInit {
  isFirstTimeUser = true;

  constructor(private modal: NgbModal) {}

  ngOnInit() {
    if (!localStorage.getItem('isFirstTimeUser')) {
      const modalData: IModalData = {
        title: 'Join Our Mailing List!',
        body: 'Sign up to receive email updates on new announcements.',
        cancelBtnText: 'Cancel',
        confirmBtnText: 'Join',
      };
      const modalRef = this.modal.open(WelcomeModalComponent);
      modalRef.componentInstance.data = modalData;
      modalRef.result.then((_res: any) => {}).catch((_err: any) => false);

  
      localStorage.setItem('isFirstTimeUser', 'false');
    }

  }
}
